<template>
  <v-timeline
    v-if="tradeDetails && tradeDetails.data"
    align-center
    dense
  >
    <v-timeline-item
      v-for="(item, idx) in tradeDetails.data.events"
      :key="idx"
      color="primary"
      small
    >
      <v-row class="pt-1">
        <v-col>
          <strong>{{ item.displayText.fin }}</strong>
          <div class="caption">
            {{ formatDate(item.timestamp).toLocaleDateString('fi-FI') }}
            klo {{ formatDate(item.timestamp)
              .toLocaleTimeString('fi-FI', { hour: '2-digit', minute: '2-digit' })
              .replace('.', ':') }}
          </div>
        </v-col>
      </v-row>
    </v-timeline-item>
  </v-timeline>
</template>
<script>
export default {
  props: {
    tradeDetails: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    formatDate(isoString) {
      return new Date(isoString);
    },
  },
};
</script>
